<template>
  <div class="container ">
    <div class="home"><router-link to="/">Zurück</router-link></div>
    <div class="row barrierefreiheitserklaerung">
      <div class="col">
        <h1>Erklärung zur Barrierefreiheit</h1>
        <p>
          Wir sind bemüht, diese Webseite im Einklang mit § 1 BayEGovV
          barrierefrei zugänglich zu machen.
        </p>
        <h2>
          Stand der Vereinbarkeit mit den Anforderungen
        </h2>
        <p>
          Diese Website ist wegen der folgenden Unvereinbarkeiten und Ausnahmen
          nur teilweise mit der Barrierefreie-Informationstechnik-Verordnung
          (BITV) vereinbar.
        </p>
        <h2>Nicht barrierefreie Inhalte</h2>
        <p>
            Die nachstehend aufgeführten Inhalte sind nicht barrierefrei:
            <ul>
                <li>Gliederungsstrukturen der Webseite sind nicht durchgängig mit den vorgesehenen HTML-Strukturelementen ausgezeichnet.</li>
                <li>Bei einzelnen HTML-Elementen können erforderliche Attribute fehlen oder die Attribute Fehler aufweisen.</li>
                <li>Die Navigationsmechanismen sind nicht einheitlich.</li>
                <li>Der Tastaturfokus ist nicht deutlich zu sehen.</li>
                <li>Die Webseite ist nicht ohne JavaScript benutzbar.</li>
            </ul>
        </p>
        <h2>Erstellung dieser Erklärung zur Barrierefreiheit</h2>
        <p>
            Diese Erklärung wurde am 23. September 2020 erstellt. Die Prüfung erfolgte als Selbstbewertung.
        </p>
        <h2>Feedback und Kontaktangaben</h2>
        <p>
            Sie können uns als Nutzer Mängel bei der Einhaltung der Anforderungen an die Barrierefreiheit mitteilen oder Informationen, die nicht barrierefrei dargestellt werden müssen, barrierefrei anfordern.
        </p>
        <p>Bitte benutzen Sie folgende Kontakt-eMail: zep-ps@bsb-muenchen.de</p>
        <h2>Durchsetzungsverfahren</h2>
        <p>
            Bleibt eine Anfrage über die oben genannte Kontaktmöglichkeit innerhalb von sechs Wochen ganz oder teilweise unbeantwortet, prüft gem. § 3 Abs. 2 Satz 1 BayEGovV das Landesamt für Digitalisierung, Breitband und Vermessung auf Antrag des Nutzers, ob im Rahmen der Überwachung gegenüber dem Verpflichteten Maßnahmen erforderlich sind.
        </p>
        <h3>Kontaktinformation der für das Durchsetzungsverfahren zuständigen Einrichtung</h3>
        <p>
            Landesamt für Digitalisierung, Breitband und Vermessung<br>
            IT-Dienstleistungszentrum des Freistaats Bayern<br>
            Durchsetzungs- und Überwachungsstelle für barrierefreie Informationstechnik<br>
            St.-Martin-Straße 47<br>
            81541 München<br>
            Telefon: +49 89 2129-1111<br>Telefax: +49 89 2129-1113<br>
            E-Mail: bitv(at)bayern.de<br >
            Website: <span class='website_text'>https://www.ldbv.bayern.de/digitalisierung/bitv.html</span><br ></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Barrierefreiheit",
};
</script>
<style scoped>
a {
  color: #ff6600;
}
.home {
  font-size: 20px;
  text-align: start;
  margin: 10px;
}
.row.barrierefreiheitserklaerung{
  margin-top:20px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 20px;
  text-align: start;
}
.col{
  padding: 0px;
}
@media (max-width: 768px) { 
  .row.barrierefreiheitserklaerung{
    font-size:15px
  }
  h1{
    font-size: 32px
  }
  h2{
    font-size: 27px
  }
  h3{
    font-size: 22px
  }
}
@media (max-width: 600px) { 
    .home {
    margin-left: 25px;
    margin-top: 25px;
  }
  .row.barrierefreiheitserklaerung{
    font-size:14px;
    margin-left:25px;
    margin-right:25px;
  }
   h1{
    font-size: 28px
  }
  h2{
    font-size: 22px
  }
  h3{
    font-size: 20px
  }
  
}
@media (max-width: 363px) { 
    .home {
    margin-left: 15px;
  }
  .row.barrierefreiheitserklaerung{
    font-size:13px;
    margin-left:15px;
    margin-right:15px;
  }
  .container{
    padding: 0px;
  }
     h1{
    font-size: 25px
  }
  h2{
    font-size: 21px
  }
  h3{
    font-size: 18px
  }
  .website_text{
    font-size: 11px
  }
  }

</style>
